import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { changeAppLanguage } from '../lib/language';
import { IS_APP_BUILD } from '../lib/buildTarget';
import LandingPage from '../pages/LandingPage';
import PublicPricingPage from '../pages/PublicPricingPage';

// post-t7-2a (bloque F, diseno 3.4 a): LAS DOS RUTAS WEB EN ESPANOL, `/es` y `/es/precios`.
//
// Montan la MISMA portada y la MISMA pagina publica de precios que `/` y `/pricing`, con el
// idioma forzado a espanol: al entrar se llama UNA vez al mecanismo central de siempre
// (`changeAppLanguage('es', user)`, lib/language.js), igual que si se tocara ES en el boton
// EN | ES; o sea que la eleccion tambien queda guardada para la siguiente visita, como con el
// boton. Mientras el idioma todavia no es espanol no se pinta nada (un instante en blanco es
// mejor que un instante en ingles encima del HTML pre-pintado en espanol).
//
// Nadie llega aqui por idioma: no hay redireccion automatica. Se llega por una liga, por un
// buscador o por el EN | ES de la propia pagina (lib/gemelaDeIdioma.js).
//
// EN LA APP rebotan como `/` y `/pricing` (App.js): `/es` al panel, como `/`, y `/es/precios` a
// `/pricing`, que hace en la app lo de siempre. Sin forzar idioma: en la app manda el perfil.
// IS_APP_BUILD es un gate de RUNTIME, como en App.js: las dos ramas viajan en los dos bundles.

export function EnEspanol({ children }) {
  const { i18n } = useTranslation();
  const { user } = useAuth();
  // El usuario del momento del montaje: la eleccion es UNA, al entrar, como un toque al boton.
  const usuario = useRef(user);
  usuario.current = user;
  useEffect(() => {
    changeAppLanguage('es', usuario.current);
  }, []);
  const yaEnEspanol = String((i18n && i18n.language) || '').toLowerCase().startsWith('es');
  return yaEnEspanol ? children : null;
}

export function PortadaEnEspanol() {
  if (IS_APP_BUILD) return <Navigate to="/dashboard" replace />;
  return <EnEspanol><LandingPage /></EnEspanol>;
}

export function PreciosEnEspanol() {
  if (IS_APP_BUILD) return <Navigate to="/pricing" replace />;
  return <EnEspanol><PublicPricingPage /></EnEspanol>;
}
